import { __extends } from "tslib";
import * as React from 'react';
var msPerMinute = 1000 * 60;
/** React component to display a past date in a friendly format relative to now. */
var FriendlyDate = /** @class */ (function (_super) {
    __extends(FriendlyDate, _super);
    function FriendlyDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FriendlyDate.prototype.componentDidMount = function () {
        globalTimer.register(this);
    };
    FriendlyDate.prototype.componentWillUnmount = function () {
        globalTimer.unregister(this);
    };
    FriendlyDate.prototype.render = function () {
        return this.props.formatter(this.props.date);
    };
    return FriendlyDate;
}(React.PureComponent));
export { FriendlyDate };
/** Singleton to manage update of all FriendlyDate controls - centralized to keep them all updating at the same time.
 *  Update period is ~1 minute. */
var FriendlyDateTimer = /** @class */ (function () {
    function FriendlyDateTimer() {
        this.components = [];
    }
    FriendlyDateTimer.prototype.register = function (component) {
        var _this = this;
        this.components.push(component);
        if (this.timerId === undefined) {
            this.timerId = window.setInterval(function () { return _this.onTimerFired(); }, msPerMinute);
        }
    };
    FriendlyDateTimer.prototype.unregister = function (component) {
        this.components = this.components.filter(function (c) { return c !== component; });
        if (!this.components.length) {
            window.clearInterval(this.timerId);
        }
    };
    FriendlyDateTimer.prototype.onTimerFired = function () {
        this.components.forEach(function (c) { return c.forceUpdate(); });
    };
    return FriendlyDateTimer;
}());
var globalTimer = new FriendlyDateTimer();
//# sourceMappingURL=FriendlyDate.js.map